import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import React, { useState, useEffect } from 'react';
import { Search, } from 'lucide-react';
import Select from 'react-select';
import ModuloPagos from '../../../views/compartedRoutes/Contabilidad/ModuloPagos';

const ModuloPagosParcial = () => {
    const {handleBusquedaServicios,busquedaServiciosOptions,getBusquedaServicios,serviciosBusqueda,setupWebSocketsServicios} = useContabilidadModel();
    const {configuracion, loadingConfiguracion} = useConfiguracion();
    const [buscarServicio, setBusquedaServicio] = useState('');

    const [formData, setFormData] = useState({
        codigo: '',
    }); 

    const busquedaServicio = (inputValue) => {
      setBusquedaServicio(inputValue);
      
      if (inputValue.length >= 2) {
          handleBusquedaServicios(inputValue);
      } else if (inputValue.length === 0) {
          // Limpiar resultados si el input está vacío
          handleBusquedaServicios([]);
      }
    };

    const servicioSeleccionado = serviciosBusqueda.find(
      servicio => servicio.codigo === formData.codigo
    );
    
    useEffect(() => {
        // Asegúrate de que configuracion.nombreEmpresa exista antes de llamar
        if (configuracion?.nombreEmpresa) {
            getBusquedaServicios(configuracion.nombreEmpresa, '');
        }
    }, [configuracion]);

    //Escuchar servicio seleccionado
    useEffect(() =>{
      if(servicioSeleccionado){
        const socketCleanup = setupWebSocketsServicios(servicioSeleccionado, servicioSeleccionado.nombreEmpresa);
                        
        return () => {
            if (socketCleanup) {
                socketCleanup();
            }
        };

      }
    },[servicioSeleccionado]);

    const getOptionFromValue = (options, value) => {
        if (!value || !options || options.length === 0) return null;
        return options.find(option => option.value === value) || null;
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData({
            ...formData,
            [name]: selectedOption ? selectedOption.value : ''
        });

    }

  return (
    <div>
      <h2>Módulo de Pagos</h2>

        {/* select de codigo */}
      <label>Buscar y seleccionar servicio:</label>
        
      <Select
        name="codigo"
        value={getOptionFromValue(busquedaServiciosOptions, formData.codigo)}
        onChange={handleSelectChange}
        onInputChange={busquedaServicio}
        options={busquedaServiciosOptions}
        placeholder="Selecciona el servicio"
        isClearable
        isSearchable
        loadingMessage={() => "Cargando clientes..."}
        noOptionsMessage={() => "No se encontraron clientes"}
        classNamePrefix="react-select"
        className="react-select-container"
      />

      <hr style={{ margin: '20px 0' }} />

      <div>
                {servicioSeleccionado ? (
                    <div>
                        <ModuloPagos
                          servicio={servicioSeleccionado}
                        >
                        </ModuloPagos>
                    </div>
                ) : (
                    <p style={{ color: '#888' }}>Selecciona un servicio para ver los detalles...</p>
                )}
      </div>

      
      
    </div>
  )
}

export default ModuloPagosParcial
